import { Typography, } from "../Typography";
import { useState, useEffect,} from "react";
import { styled, } from "styled-components";
import { Cross, } from "../../icons";


export const Banner = ({
	open = 1753102800000,
	storageKey = "bracket-banner-test",
	routes,
}: { open?: number; storageKey?: string; routes?: string[]; }) => { 

	const forced = globalThis.location.search.toLowerCase().includes("forcebanner=true");
	const displayRoute = typeof routes === "undefined" || routes.includes(globalThis.location.pathname);
	const [seen, setSeen] = useState(localStorage.getItem(storageKey) === "true");
	const [visible, setVisible] = useState(Date.now() > open || forced);


	useEffect(() => {
		if(!visible) {
			const inte = setInterval(() => {
				if(Date.now() > open) {
					setVisible(true);
				}
			}, 1000);
			return () => clearInterval(inte);
		}
	}, [visible, open,]);


	const openLink = () => {
		window.open("https://app.liquidity.land/project/Bracket", "_blank");
	}


	const close = () => {
		localStorage.setItem(storageKey, "true");
		setSeen(true);
	}

	if((seen || !visible || !displayRoute) && !forced)
		return null;


	return (
		<Container>
			<GradOverlay />
			<OV />
			<BracketLeft src="/bracket-braces.png" alt="bracket left brace" />
			<BracketRight src="/bracket-braces.png" alt="bracket right brace" />
			<Brace />
			<ContentBrace>
				<Typography variant="p" color="var(--primary)">Liquidity.land x [Bracket]</Typography>
				<Typography variant="p" color="var(--text-paragraph)" style={{ textDecoration: "underline", textUnderlineOffset: "2px", cursor: "pointer", fontWeight: 300,  }} onClick={openLink}>PARTNERSHIP ANNOUNCE: USDC+ Deposits Eligible For 2x Points</Typography>
				<Typography variant="p" color="var(--primary)">100% [BARS] Boost Available</Typography>
			</ContentBrace>
			<Brace $justify="flex-end" $marginRight="1em">
				<CloseButton onClick={close}>
					<Cross scale={.75}/>
				</CloseButton>
			</Brace>
		</Container>
	);
};


const Brace = styled.div<{ $align?: "flex-start" | "center" | "flex-end"; $justify?: "flex-start" | "center" | "flex-end"; $zIndex?: number; $marginRight?: string; }>`
	display: flex;
	flex: 1;
	align-items: ${({ $align }) => $align ? $align : undefined };
	justify-content: ${({ $justify }) => $justify ? $justify : undefined };
	z-index: ${({ $zIndex }) => $zIndex ? $zIndex : undefined };
	margin-right: ${({ $marginRight }) => $marginRight ? $marginRight : undefined };
`;


const OV = styled.div`
	background: url("/noise2.png") repeat;
	background-size: 200px;
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	opacity: .1;
	mix-blend-mode: color-dodge;
	@media (max-width: 768px) {
		display: none;
	}
`

const Container = styled.div`
	display: flex;
	padding: 30px;
	background-size: 200px;
	position: relative;
	max-height: 68px;
	overflow: hidden;
	justify-content: center;
	align-items: center;
	border-radius: 4px;
	box-shadow: 0px 0px 3px 5px #00000026;
	margin: 0.5rem;
	@media (max-width: 768px) {
		max-height: unset;
		margin: 1rem;
		margin-top: 5rem;
		border: 2px solid var(--primary);
		padding: 16px;

	}
}
`;

const ContentBrace = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: center;

	gap: 16px;
	z-index: 99;
	position: relative;
	@media (max-width: 768px) {
		flex-direction: column;
		align-items: center;
		gap: 8px;
		>p {
			text-align: center;
		}
	}
`;

const BracketLeft = styled.img`
	position: absolute;
	left: 10%;
	top: 0;
	height: 100%;
	transform: scaleX(-1);
	scale: 2;
	opacity: 0.65;
	@media (max-width: 768px) {
		display: none;
	}
`;

const BracketRight = styled.img`
	position: absolute;
	right: 10%;
	top: 0;
	height: 100%;
	scale: 1.8;
	opacity: 0.65;
	@media (max-width: 768px) {
		display: none;
	}
`;

const GradOverlay = styled.div`
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background-size: 100% 100%;
	background-position: 0px 0px,0px 0px,0px 0px,0px 0px;
	background-image: radial-gradient(200% 1000% at 50% 50%, #024C2CFF 1%, #FF000000 99%),
										radial-gradient(80% 1000% at 0% 50%, #0F261CFF 1%, #FF000000 140%),
										radial-gradient(80% 1000% at 100% 50%,rgb(8, 18, 14) 1%,rgb(23, 67, 48) 50%, #0F261CFF 140%);
	background-blend-mode: hard-light;
`;

const CloseButton = styled.div`
	display: flex;
	width: 1rem;
	height: 1rem;
	cursor: pointer;
`;
